/**
 * 网络请求工具包
 */
import axios from "axios";
const baseUrl = process.env.VUE_APP_BASE_API;
import {Message,} from 'element-ui'
const service = axios.create({
    baseURL: baseUrl, // api的base_url
    timeout: 50000 // 请求超时时间
});
service.interceptors.request.use(
    config => {    
        console.log(config)   
        return config;
    },
    error => {
        return error;
    }
);

service.interceptors.response.use(
    response => {
        // if(response.data.resultCode!=='0'){
        //     app.$createToast({
        //         txt: '请求错误',
        //         type: 'txt'
        //     }).show()
        //     return Promise.reject('错误');
        // }else{
            return Promise.resolve(response.data);
        // }
        
    },
    error => {
        if (error.response) {
            // if (status === 401) {
            //     app.$createToast({
            //         txt: '请求错误',
            //         type: 'txt'
            //     }).show()
            // }
            // if (status == 403) {
            //     app.$createToast({
            //         txt: '请求错误',
            //         type: 'txt'
            //     }).show()
            // }
            // if (status === 400 ||  status === 405||status === 500 || status === 402) {
            //     app.$createToast({
            //         txt: '请求错误',
            //         type: 'txt'
            //     }).show()
            // }
            // app.$createToast({
            //     txt: '请求错误',
            //     type: 'txt'
            // }).show()
        }
        console.log('错误')
        Message.error({
            message: '系统错误',
            onClose: function () {
            }
          })
        // app.$createToast({
        //     txt: '系统错误',
        //     type: 'txt'
        // }).show()
        // return Promise.reject(error.response.data);
        return Promise.reject(error);
    }
);

export default service;
